// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://nihongotech.teqseq.com";
// Short form for the per-page <title> suffix (space-limited, ~20 routes use
// it) - kept separate from the full brand name used for og:site_name, per
// the "short name where space is limited" branding rule.
const SITE_NAME = "NihongoTech";
const OG_SITE_NAME = "NihongoTech by TeqSeq";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

// react-helmet-async only replaces/removes tags it rendered itself (marked
// with its own data-rh attribute) - it has no way to know the static
// description/canonical/OG/Twitter tags in public/index.html are meant to
// be superseded, so it appends its tags alongside them instead of replacing
// them. Since every route now renders its own <Seo>, those static tags
// (marked data-default-seo - see index.html) are only a fallback for
// crawlers that never run this JS in the first place; once React has
// mounted here, they'd otherwise sit alongside Helmet's real ones as
// duplicate/conflicting meta tags. Strip them once, the first time any page
// actually mounts a <Seo>.
let staticFallbackTagsRemoved = false;
function removeStaticFallbackTags() {
    if (staticFallbackTagsRemoved) return;
    staticFallbackTagsRemoved = true;
    document.querySelectorAll("[data-default-seo]").forEach((tag) => tag.remove());
}

/**
 * Per-page title/description/canonical/OG tags. index.html only carries one
 * static set shared by every route - this is what makes each route report
 * its own instead, and matters more than it looks: an unchanging
 * <link rel="canonical"> pointing every subpage at "/" tells search engines
 * to index the homepage in that subpage's place.
 */
function Seo({ title, description, path, image = DEFAULT_IMAGE, noindex = false, suffixBrand = true }) {
    const fullTitle = suffixBrand ? `${title} | ${SITE_NAME}` : title;
    const canonical = `${SITE_URL}${path}`;

    useEffect(() => {
        removeStaticFallbackTags();
    }, []);

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={canonical} />
            {noindex && <meta name="robots" content="noindex" />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={OG_SITE_NAME} />
            <meta property="og:url" content={canonical} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}

export default Seo;
